export enum TransactionTypes {
  PAY_IN = 'PAYIN',
  PAY_OUT = 'PAYOUT',
  TRANSFER = 'TRANSFER'
}
export enum TransactionStatus {
  CREATED = 'CREATED',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED'
}

export default {
  TransactionTypes,
  TransactionStatus,
};
